<template>
    <section class="partners-section">
        <div class="partners-slider">
        <div class="slider-track">
            <img v-for="(logo, index) in duplicatedLogos" :key="`logo- ${index}`" :src="logo" class="partner-logo" :alt="'Parceiro ' + (index + 1)">
        </div>
        </div>
    </section>
</template>

<script>
import logos from '@/data/logos';
export default {

  data() {
    return {
      dataLogos: logos,
    };
  },

  computed: {
    duplicatedLogos() {
      return [...this.dataLogos, ...this.dataLogos, ...this.dataLogos, ...this.dataLogos];
    }
  }
};
</script>

<style scoped lang="scss">
.partners-section {
  height: 10vh;
  width: 100vw;
  overflow: hidden;
  display: flex;
  align-items: center;
  background-color: var(--anis);
}

.partners-slider {
  white-space: nowrap;
  overflow: hidden;
  position: relative;
}

.slider-track {
  display: inline-block;
  white-space: nowrap;
  animation: scroll 25s linear infinite;
}

.partner-logo {
  height: 38px;
  max-width: 160px;
  margin: 0 40px;
  vertical-align: middle;
  object-fit: contain;
}

@keyframes scroll {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}
</style>
